import { Switch } from '@affine/component';
import {
  SettingRow,
  SettingWrapper,
} from '@affine/component/setting-components';
import { usePrivateWorkspaces } from '@affine/core/components/workspace-selector/private-workspaces';
import { EditorSettingService } from '@affine/core/modules/editor-setting';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

export const PrivateWorkspaceSetting = () => {
  const t = useI18n();
  const workspaceId = useService(WorkspaceService).workspace.id;
  const editorSetting = useService(EditorSettingService).editorSetting;
  const privateWorkspaces = usePrivateWorkspaces();
  const isPrivate = privateWorkspaces.includes(workspaceId);

  const onChange = useCallback(
    (checked: boolean) => {
      const others = privateWorkspaces.filter(id => id !== workspaceId);
      editorSetting.privateWorkspaces.set(
        checked ? [...others, workspaceId] : others
      );
    },
    [editorSetting, privateWorkspaces, workspaceId]
  );

  return (
    <SettingWrapper>
      <SettingRow
        name={t['com.affine.settings.workspace.private.title']()}
        desc={t['com.affine.settings.workspace.private.description']()}
      >
        <Switch
          checked={isPrivate}
          onChange={onChange}
          data-testid="private-workspace-switch"
        />
      </SettingRow>
    </SettingWrapper>
  );
};
